import api from './axios';

export const listar    = ()          => api.get('/usuarios/');
export const buscarId  = (id)        => api.get(`/usuarios/${id}`);
export const criar     = (data)      => api.post('/usuarios/', data);
export const atualizar = (id, data)  => api.patch(`/usuarios/${id}`, data);
